function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.2593 1.98C21.0123 1.74 20.642 1.62 20.2716 1.74C17.5556 2.34 14.8395 1.74 12.6173 0.18C12.2469 -0.06 11.6296 -0.06 11.2593 0.18C8.91358 1.74 6.19753 2.34 3.48148 1.74C2.8642 1.62 2.12346 2.1 2 2.7C2 2.82 2 2.82 2 2.94V11.94C2 15.42 3.7284 18.66 6.69136 20.7L11.2593 23.82C11.6296 24.06 12.2469 24.06 12.7407 23.82L17.3086 20.7C20.2716 18.66 22 15.42 22 11.94V2.94C21.7531 2.58 21.6296 2.22 21.2593 1.98ZM14.3457 13.26H13.1111V14.46C13.1111 15.18 12.6173 15.66 11.8765 15.66C11.1358 15.66 10.642 15.18 10.642 14.46V13.26H9.40741C8.66667 13.26 8.17284 12.78 8.17284 12.06C8.17284 11.34 8.66667 10.86 9.40741 10.86H10.642V9.66C10.642 8.94 11.1358 8.46 11.8765 8.46C12.6173 8.46 13.1111 8.94 13.1111 9.66V10.86H14.3457C15.0864 10.86 15.5802 11.34 15.5802 12.06C15.5802 12.78 15.0864 13.26 14.3457 13.26Z",
  fill: "currentColor"
});

var SvgSecurity = function SvgSecurity(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSecurity, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/security.3af60838.svg";
export { ForwardRef as ReactComponent };